import { Extension } from '@tiptap/core';

import { FONT_SIZES } from '../constants';

import '@tiptap/extension-text-style';

import type { FontSizeConfig, FontSizeValue } from '../types';

export const FontSize = Extension.create({
    name: 'fontSize',

    addOptions() {
        return {
            types: ['textStyle'],
            overrideFontSize: null as FontSizeConfig | null,
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: ['paragraph'],
                attributes: {
                    class: {},
                },
            },
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }

                            const customFontSize =
                                this.options.overrideFontSize?.[attributes.fontSize];

                            const fontSize =
                                customFontSize || FONT_SIZES[attributes.fontSize as FontSizeValue];

                            if (!fontSize) {
                                return {};
                            }

                            return {
                                class:
                                    'fun-text-[length:var(--fs-m)] sm:fun-text-[length:var(--fs-t)] md:fun-text-[length:var(--fs-d)]' +
                                    ' ' +
                                    'fun-leading-[var(--lh-m)] sm:fun-leading-[var(--lh-t)] md:fun-leading-[var(--lh-d)]' +
                                    ' ' +
                                    'fun-tracking-[var(--ls-m)] sm:fun-tracking-[var(--ls-t)] md:fun-tracking-[var(--ls-d)]',
                                style:
                                    `--fs-m: ${fontSize.base.sizePx}px;` +
                                    `--fs-t: ${
                                        fontSize.tablet?.sizePx ?? fontSize.base.sizePx
                                    }px;` +
                                    `--fs-d: ${
                                        fontSize.desktop?.sizePx ?? fontSize.base.sizePx
                                    }px;` +
                                    `--lh-m: ${fontSize.base.lineHeight};` +
                                    `--lh-t: ${
                                        fontSize.tablet?.lineHeight ?? fontSize.base.lineHeight
                                    };` +
                                    `--lh-d: ${
                                        fontSize.desktop?.lineHeight ?? fontSize.base.lineHeight
                                    };` +
                                    `--ls-m: ${fontSize.base.letterSpacing};` +
                                    `--ls-t: ${
                                        fontSize.tablet?.letterSpacing ??
                                        fontSize.base.letterSpacing
                                    };` +
                                    `--ls-d: ${
                                        fontSize.desktop?.letterSpacing ??
                                        fontSize.base.letterSpacing
                                    };`,
                            };
                        },
                    },
                },
            },
        ];
    },
});

export default FontSize;
